// Constants
import { checkMarkIconProps, sendIconProps, taskListIconProps } from "../../../icons/icons.styles";
// Controls
import { Dropdown } from "@fluentui/react/lib/Dropdown";
// Utilities
import React from "react";
// Styles
import { Icon, useTheme } from "@fluentui/react";
import { getClassNames, iconStyles, getDropDownStyles } from "./UnoSwitchViewDropdown.styles";
export var NavView = /*#__PURE__*/ function(NavView) {
    NavView["tasksView"] = "tasksView";
    NavView["publisherView"] = "publisherView";
    return NavView;
}({});
export const UnoSwitchViewDropdown = ({ currentView, onChange, classNames, isPublisherViewVisible, strings })=>{
    const [currentSelectedKey, setCurrentSelectedKey] = React.useState(currentView);
    const theme = useTheme();
    // early return if publisher view is not visible
    if (!isPublisherViewVisible && currentView !== "publisherView") return null;
    const options = [
        {
            key: "tasksView",
            text: strings.tasksView,
            data: {
                iconProps: taskListIconProps
            }
        },
        {
            key: "publisherView",
            text: strings.publisherView,
            data: {
                iconProps: sendIconProps
            }
        }
    ];
    const onRenderOption = (option)=>{
        const isSelected = option.key === currentSelectedKey;
        const { optionContainer } = getClassNames(isSelected);
        return /*#__PURE__*/ React.createElement("div", {
            className: optionContainer
        }, isSelected && /*#__PURE__*/ React.createElement(Icon, {
            styles: iconStyles,
            ...checkMarkIconProps
        }), option.data?.iconProps && /*#__PURE__*/ React.createElement(Icon, {
            ...option.data.iconProps,
            styles: iconStyles
        }), /*#__PURE__*/ React.createElement("span", null, option.text));
    };
    const onChangeHandler = (event, option)=>{
        option && setCurrentSelectedKey(option.key);
        onChange?.(event, option);
    };
    const onRenderTitle = (selectedOptions)=>{
        const { optionContainer } = getClassNames(true);
        const option = selectedOptions?.[0];
        return /*#__PURE__*/ React.createElement("div", {
            className: optionContainer
        }, option?.data?.iconProps && /*#__PURE__*/ React.createElement(Icon, {
            styles: iconStyles,
            ...option.data.iconProps
        }), /*#__PURE__*/ React.createElement("span", null, option?.text));
    };
    return /*#__PURE__*/ React.createElement(Dropdown, {
        options: options,
        onRenderOption: onRenderOption,
        onRenderTitle: onRenderTitle,
        defaultSelectedKey: currentView,
        styles: getDropDownStyles(theme),
        onChange: onChangeHandler,
        className: classNames
    });
};
